var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"mb-5"},[_c('v-col',[_c('v-data-table',{staticClass:"elevation-3",staticStyle:{"border":"1px solid black"},attrs:{"dense":"","headers":_vm.headers,"items":_vm.icraSevkTarihleri,"item-key":"name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }